import { IconSettings } from '../../settings/icons';

export function Schema() {
  return {
    label: 'Feature Grid',
    key: 'feature-grid',
    fields: [
      {
        label: 'Heading',
        name: 'heading',
        component: 'text',
      },
      {
        label: 'Description',
        name: 'description',
        component: 'textarea',
      },
      {
        label: 'Grid Items',
        name: 'items',
        component: 'group-list',
        fields: [
          IconSettings,
          {
            label: 'Heading',
            name: 'heading',
            component: 'text',
          },
          {
            label: 'Description',
            name: 'description',
            component: 'textarea',
          },
          {
            label: 'Link',
            name: 'link',
            component: 'link',
          },
        ],
        itemProps: {
          label: '{{item.heading}}',
        },
      },
      {
        label: 'Grid Columns',
        name: 'gridColumns',
        component: 'select',
        options: [
          {
            label: '1',
            value: '1',
          },
          {
            label: '2',
            value: '2',
          },
          {
            label: '3',
            value: '3',
          },
          {
            label: '4',
            value: '4',
          },
        ],
        defaultValue: '3',
        description: 'Applies to desktop only. Mobile will be 1 column',
      },
    ],
  };
}
